import { render, staticRenderFns } from "./adminrightclick.vue?vue&type=template&id=4d3535ce&"
import script from "./adminrightclick.vue?vue&type=script&lang=js&"
export * from "./adminrightclick.vue?vue&type=script&lang=js&"
import style0 from "./adminrightclick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports